import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import employee from '../../class/employee';

// Guard di rotta: verifica token e qualifica live via checkToken (mai dalla
// cache localStorage). allowed = qualifiche ammesse (3 = Magazzinieri).
// Il check dipende dal pathname: navigando tra due rotte protette React riusa
// la stessa istanza del guard, con deps vuote l'effect non ripartirebbe.
function RequireQualifica({ allowed, children }) {
    const [ready, setReady] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setReady(false);
        const user_obj = new employee();
        user_obj.isLogged().then(({ qualifica }) => {
            if (allowed.includes(qualifica)) {
                setReady(true);
            } else if (qualifica === 3) {
                navigate('/orders');
            } else {
                navigate('/login');
            }
        }).catch(() => {
            navigate('/login');
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    return ready ? children : null;
}

export default RequireQualifica;
